module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-125.c0ad6fe.woff2";